// internal
import { storage } from './index.js';

// storage
import { updateFilterRecord, removeLegacyFilterOptionKeys } from '../../storage/indexeddb';

const filterLsKeyMap = {
    recommend: 'filter.recommend',
    search: 'filter.search',
    trending: 'filter.trending',
    explore: 'filter.explore',
};

function setClientFilter(name, filterTypes) {
    const saved = storage.localStorage.getValue(filterLsKeyMap[name]) ?? [];
    const myFilters = filterTypes.map((filterType) => {
        const savedEntry = saved.find((s) => s.filterId === filterType._id);
        return (
            savedEntry ?? {
                filterId: filterType._id,
                name: filterType.name,
                value: JSON.stringify(['']),
                inputValue: JSON.stringify(['']),
                display: JSON.stringify(['']),
                hashValue: filterType._id,
            }
        );
    });
    storage.transience.setState(`filter.${name}.selected`, myFilters);
}

// Stores a filter list response in the list's IndexedDB record and returns the filters to use.
// Each part follows the same rule: `data: null` means "unchanged" and the stored data is kept.
//   filterOptions are rebuilt from scratch: an entry keeps its downloaded body only when its hash is unchanged,
//   and options no longer in the response disappear, so nothing is left behind.
// Bodies already downloaded go into memory, so opening those options needs no request.
async function saveFilterList(group, { filters, filterOptions }) {
    removeLegacyFilterOptionKeys();
    let saved;
    await updateFilterRecord(group, (rec) => {
        const nextFilters = { data: filters.data ?? rec.filters.data ?? [], meta: filters.meta };

        let nextOptions = rec.filterOptions;
        if (filterOptions?.data) {
            const prev = new Map(rec.filterOptions.data.map((e) => [e._id, e]));
            nextOptions = {
                data: filterOptions.data.map(({ _id, hash }) => {
                    const old = prev.get(_id);
                    return { _id, hash, data: old && old.hash === hash ? (old.data ?? null) : null };
                }),
                meta: filterOptions.meta,
            };
        } else if (filterOptions?.meta) {
            nextOptions = { ...rec.filterOptions, meta: filterOptions.meta };
        } // else: server without filterOptions — keep what we have

        saved = { filters: nextFilters, filterOptions: nextOptions };
        return saved;
    });
    for (const e of saved.filterOptions.data) {
        if (!e.data) continue;
        const exists = storage.transience.getValue('filter.option.data').some((x) => x._id === e._id);
        if (exists) storage.transience.updateState('filter.option.data', (x) => x._id === e._id, e.data);
        else storage.transience.addState('filter.option.data', e.data);
    }
    return saved.filters.data;
}

export { setClientFilter, saveFilterList };
